import React, { useState } from 'react';
import { useMedia } from 'react-use';
import useQueryWithCallbacks from '../../../common/CommonUseQuery';
import { BREAKPOINTS } from '../../../common/constants';
import CommonCard from '../../../components/CommonCard';
import CommonTable from '../../../components/CommonTable';
import Portal from '../../../components/Portal';
import SearchComponent from '../../../components/SearchComponent';
import { GET_USERS } from '../graphql/Queries';

const UserTable = () => {
  const initialUserFilter = {
    skip: 0,
    limit: 10,
    search: '',
    sortBy: { field: 'id', order: 'ASC' },
  };
  const initialPaginationValue = {
    total: 0,
    current: 1,
  };
  const [paginationProp, setPaginationProp] = useState(initialPaginationValue);
  const [userFilter, setUserFilter] = useState(initialUserFilter);
  const [sortedInfo, setSortedInfo] = useState({});
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);

  const { loading, data } = useQueryWithCallbacks(GET_USERS, {
    fetchPolicy: 'network-only',
    variables: {
      filter: userFilter,
    },
    onError() {},
  });
  const getData = (value) => {
    setUserFilter({ ...userFilter, search: value });
  };

  const handleTableChange = (pagination, paginationFilter, sorter) => {
    const { current } = pagination;
    const skip = (current - 1) * pagination?.pageSize;
    setPaginationProp({ ...paginationProp, ...pagination });
    setSortedInfo(sorter);
    if (sorter?.column) {
      setUserFilter({
        ...userFilter,
        skip,
        limit: pagination?.pageSize,
        sortBy: {
          field: sorter?.columnKey,
          order: sorter?.order === 'ascend' ? 'ASC' : 'DESC',
        },
      });
    } else {
      setUserFilter({
        ...userFilter,
        sortBy: {
          field: 'id',
          order: 'ASC',
        },
      });
    }
  };

  const columns = [
    {
      title: '#',
      dataIndex: '',
      key: 'id',
      render: (text, record, index) => {
        return <>{index + 1}</>;
      },
      width: '15%',
    },

    {
      title: 'USERNAME',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === 'name' && sortedInfo?.order,
      width: '30%',
    },
    {
      title: 'EMAIL',
      dataIndex: 'email',
      key: 'email',
      sorter: true,
      sortOrder: sortedInfo?.columnKey === 'email' && sortedInfo?.order,
      width: '60%',
    },
  ];
  return (
    <>
      <Portal portalId="header-right-content">
        <div className="users-search">
          <SearchComponent
            id="search-container-id"
            name="Users"
            getData={getData}
          />
        </div>
      </Portal>
      {isDesktopViewport ? (
        <CommonTable
          loadingData={loading}
          columns={columns}
          data={data?.superAdminList?.data || []}
          onChange={handleTableChange}
          rowKey={(obj) => obj.id}
          paginationConfig={paginationProp}
        />
      ) : (
        <div className="users-card pointer">
          {data?.superAdminList?.data?.map((userData) => {
            return (
              <div key={userData?.id}>
                <CommonCard>
                  <div>
                    <div className="card-header">
                      <h1>{userData?.name}</h1>
                    </div>
                    <div className="card-content">
                      <p>{userData?.email}</p>
                    </div>
                  </div>
                </CommonCard>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default UserTable;
